import { render, staticRenderFns } from "./MenuBulkImport.vue?vue&type=template&id=74ea8d49&scoped=true"
import script from "./MenuBulkImport.vue?vue&type=script&lang=js"
export * from "./MenuBulkImport.vue?vue&type=script&lang=js"
import style0 from "./MenuBulkImport.vue?vue&type=style&index=0&id=74ea8d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea8d49",
  null
  
)

export default component.exports